/* eslint-disable */

/** unique or primary key constraints on table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  UdfColumnTypePkey = 'udf_column_type_pkey'
}

export enum ArgoUdfColumnTypeEnum {
  /** Event */
  Event = 'event',
  /** Material */
  Material = 'material'
}

/** select columns of table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "argo.udf_column_type" */
export enum ArgoUdfColumnTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

